/**
 * RoleName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectRoleValue } from '../../services/roles/selectors';

interface Props {
    name?: string;
}

export class RoleName extends React.PureComponent<Props> {
    render() {
        return this.props.name || null;
    }
}

const mapStateToProps = createStructuredSelector({
    name: makeSelectRoleValue('name')
});

export default connect(mapStateToProps)(RoleName);
